import { useContext } from 'react';
import languageContext from '@/context/language';
import { useCountry } from './use-country';

export const usePriceFormat = (lang = '') => {
  const { isKR } = useCountry();
  if (!lang) {
    lang = useContext(languageContext).lang;
  }
  const getPriceFormat = (value) => {
    if (!value) value = 0;
    let formatOption = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
    if (isKR) {
      formatOption = { maximumFractionDigits: 0, minimumFractionDigits: 0 };
    }
    return new Intl.NumberFormat(lang, formatOption).format(value);
  };

  return getPriceFormat;
};
